import type { TemplateEntityV1beta3 } from '@backstage/plugin-scaffolder-react';

/** Uses existing `backstage.io/domain` — agent `list_templates` is unchanged. */
function domain(entity: TemplateEntityV1beta3): string {
  return entity.metadata.annotations?.['backstage.io/domain'] ?? '';
}

const REDIS_LAB = new Set([
  'redis-software-jumpstart',
  'basic-data-migration',
  'caching',
  'performance-optimization',
]);

const OBSERVABILITY = new Set([
  'advanced-monitoring',
  'observability',
  'monitoring',
]);

const ALL_GROUPED_DOMAINS = new Set([
  ...REDIS_LAB,
  ...OBSERVABILITY,
  'k8s-openshift-jumpstart',
  'redis-data-integration',
  'jump-start-redis-cloud',
  'integration-labs',
  'image-management',
]);

export const scaffolderTemplateGroups = [
  {
    title: 'Redis lab',
    filter: (entity: TemplateEntityV1beta3) => REDIS_LAB.has(domain(entity)),
  },
  {
    title: 'Kubernetes (EKS / GKE)',
    filter: (entity: TemplateEntityV1beta3) =>
      domain(entity) === 'k8s-openshift-jumpstart',
  },
  {
    title: 'CDC & RDI',
    filter: (entity: TemplateEntityV1beta3) =>
      domain(entity) === 'redis-data-integration',
  },
  {
    title: 'Redis Cloud network',
    filter: (entity: TemplateEntityV1beta3) =>
      domain(entity) === 'jump-start-redis-cloud',
  },
  {
    title: 'Observability',
    filter: (entity: TemplateEntityV1beta3) => OBSERVABILITY.has(domain(entity)),
  },
  {
    title: 'Integration labs',
    filter: (entity: TemplateEntityV1beta3) =>
      domain(entity) === 'integration-labs',
  },
  {
    title: 'Platform & images',
    filter: (entity: TemplateEntityV1beta3) =>
      domain(entity) === 'image-management',
  },
  {
    title: 'Other templates',
    filter: (entity: TemplateEntityV1beta3) =>
      !ALL_GROUPED_DOMAINS.has(domain(entity)),
  },
];
